 
function toggleDeliveryInstructions() {
  const atlRadio = document.getElementById('authority-to-leave');
  const sigRadio = document.getElementById('signature-required');
  const atlOption = document.getElementById('atl-option');
  const sigOption = document.getElementById('sig-option');
  const instructionsWrapper = document.getElementById('delivery-instructions-wrapper');
  const instructionsInput = document.getElementById('delivery-instructions');
  const charCounter = document.getElementById('char-counter');
  
  if (atlRadio.checked) {
    atlOption.style.borderColor = '#5c9fd6';
    atlOption.style.background = '#f0f7ff';
    sigOption.style.borderColor = 'transparent';
    sigOption.style.background = '#f8f9fa';
    instructionsWrapper.style.display = 'block';
  } else if (sigRadio.checked) {
    sigOption.style.borderColor = '#5c9fd6';
    sigOption.style.background = '#f0f7ff';
    atlOption.style.borderColor = 'transparent';
    atlOption.style.background = '#f8f9fa';
    instructionsWrapper.style.display = 'none';
    instructionsInput.value = '';
    charCounter.textContent = '97 characters remaining';
    charCounter.classList.remove('warning');
  }
}

// Character counter
/*document.addEventListener('DOMContentLoaded', function() {
  const instructionsInput = document.getElementById('delivery-instructions');
  const charCounter = document.getElementById('char-counter');
  
  if (instructionsInput && charCounter) {
    instructionsInput.addEventListener('input', function() {
      const remaining = 97 - this.value.length;
      const word = remaining === 1 ? 'character' : 'characters';
      charCounter.textContent = remaining + ' ' + word + ' remaining';
      
      if (remaining < 20) {
        charCounter.classList.add('warning');
      } else {
        charCounter.classList.remove('warning');
      }
    });
  }
});*/

/*(function () {
  function init() {
    const instructionsInput = document.getElementById('delivery-instructions');
    const charCounter = document.getElementById('char-counter');

    if (!instructionsInput || !charCounter) {
      // Retry until elements exist
      setTimeout(init, 200);
      return;
    }

    instructionsInput.addEventListener('input', function () {
      const remaining = 97 - this.value.length;
      const word = remaining === 1 ? 'character' : 'characters';
      charCounter.textContent = remaining + ' ' + word + ' remaining';

      if (remaining < 20) {
        charCounter.classList.add('warning');
      } else {
        charCounter.classList.remove('warning');
      }
    });
  }

  init();
})();*/

/* New Character counter */
(() => {
  const MAX = 97;
  const WARN = 20;

  function update(input, counter) {
    const r = MAX - input.value.length;
    const word = (r === 0 || r === 1) ? "character" : "characters";
    counter.textContent = `${r} ${word} remaining`;
    counter.classList.toggle("warning", r < WARN);
  }

  function initOne(input) {
    if (input.dataset.hasCounter) return;
    const counter =
      input.closest("form")?.querySelector("#char-counter") ||
      document.getElementById("char-counter");

    if (!counter) return;

    input.dataset.hasCounter = "true";
    input.addEventListener("input", () => update(input, counter));
    update(input, counter);
  }

  function scan() {
    document
      .querySelectorAll("#delivery-instructions")
      .forEach(initOne);
  }

  // Initial
  document.addEventListener("DOMContentLoaded", scan);

  // Shopify dynamic section events
  ["shopify:section:load", "shopify:section:select", "shopify:section:deselect"]
    .forEach(evt => document.addEventListener(evt, scan));

  // Cart drawer changes (AJAX / dynamic DOM updates)
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();



 
 
 (function() {
  'use strict';
  
  const CONFIG = {
    FREE_SHIPPING_THRESHOLD: 7500,
    AFTERPAY_MIN: 50,
    AFTERPAY_MAX: 2000,
    FLAMMABLE_TAG: 'flammable'
  };
  
  const COLOURS = {
    RED: '#DC1927',
    YELLOW: '#FFCC00'
  };
  
  // Format price
  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  
  // Get cart data
  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      return await response.json();
    } catch (error) {
      console.error('Cart fetch error:', error);
      return null;
    }
  }
  
  // Check for flammable items
  function hasFlammableItems(items) {
    return items.some(item => {
      if (item.product_tags) {
        return item.product_tags.includes(CONFIG.FLAMMABLE_TAG);
      }
      const searchStr = (item.handle + ' ' + item.product_title).toLowerCase();
      return searchStr.includes('flammable');
    });
  }
  
  const progressBar = document.getElementById('progress-bar-fill');

  // Update progress bar
  function updateProgressBar(cartTotal) {
    const progressBar = document.getElementById('progress-bar-fill');
    const progressMessage = document.getElementById('progress-message');
    const progressAmount = document.getElementById('progress-remaining-amount');
    
    if (!progressBar || !progressMessage) return;
    
    const threshold = CONFIG.FREE_SHIPPING_THRESHOLD;
    const percentage = Math.min((cartTotal / threshold) * 100, 100);
    const remaining = threshold - cartTotal;
    
    progressBar.style.width = percentage + '%';
    
    if (cartTotal >= threshold) {
      
      progressBar.classList.add('progress-complete');
      progressBar.style.backgroundColor = COLOURS.YELLOW;
      
      progressMessage.innerHTML = '<span class="progress-success">🎉 You have unlocked FREE STANDARD SHIPPING!</span>';
    } else {
      progressBar.classList.remove('progress-complete');
      progressBar.style.backgroundColor = COLOURS.RED;
      
      if (progressAmount) {
        progressAmount.textContent = formatPrice(remaining);
      }
    }
  }
  
  // Update conditional displays
  function updateConditionalDisplay(cartTotal, cartItems) {
    const expressBox = document.getElementById('express-post-upsell');
    const flammableBox = document.getElementById('flammable-notice');
    

    if (!expressBox && !flammableBox) return;
    
    const threshold = CONFIG.FREE_SHIPPING_THRESHOLD;
    const hasFlammable = hasFlammableItems(cartItems);
    
    if (cartTotal < threshold) {
      if (expressBox) expressBox.style.display = 'none';
      if (flammableBox) flammableBox.style.display = 'none';
    } else if (hasFlammable) {
      if (expressBox) expressBox.style.display = 'none';
      if (flammableBox) flammableBox.style.display = 'block';
    } else {
      if (expressBox) expressBox.style.display = 'block';
      if (flammableBox) flammableBox.style.display = 'none';
    }
  }


  
  // Update Afterpay
  function updateAfterpay(cartTotal) {
    const afterpayMessage = document.getElementById('afterpay-message');
    const afterpayAmount = document.getElementById('afterpay-amount');
    
    if (!afterpayMessage || !afterpayAmount) return;
    
    const cartTotalDollars = cartTotal / 100;
    
    if (cartTotalDollars >= CONFIG.AFTERPAY_MIN && cartTotalDollars <= CONFIG.AFTERPAY_MAX) {
      const instalmentAmount = (cartTotalDollars / 4).toFixed(2);
      afterpayAmount.textContent = '$' + instalmentAmount;
      afterpayMessage.style.display = 'flex';
    } else {
      afterpayMessage.style.display = 'none';
    }
  }
  
  // Main update function
  async function updateCartCustomisations() {
    try {
      const cartData = await getCartData();
      if (!cartData) return;
      
      const cartTotal = cartData.total_price;
      const cartItems = cartData.items;
      
      updateProgressBar(cartTotal);
      //  updateConditionalDisplay(cartTotal, cartItems);
      updateAfterpay(cartTotal);
      
    } catch (error) {
      console.error('Cart update error:', error);
    }
  }
  
  // Event listeners
  function initListeners() {
    document.addEventListener('cart:drawer:open', updateCartCustomisations);
    document.addEventListener('cart:updated', updateCartCustomisations);
    
    const cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');
    cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        setTimeout(updateCartCustomisations, 300);
      });
    });
  }
  
  // Initialize
  function init() {
    updateCartCustomisations();
    initListeners();
    console.log('Cosmetix cart customisations loaded');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  window.CosmetixCart = { update: updateCartCustomisations };
  
})();


